/*
 * 文件说明: 展示协议数据，请求失败时仅显示当前组件的无数据状态。
 */
import React from 'react'
import {query} from '../LiquityData'
import {nowTimestamp} from '../../utils/Timestamps'
import {queryLQTYPriceV2} from './LqtyPrices'
import dayjs from 'dayjs'

class LusdAPR extends React.Component {
    state = {
        depositedLUSD: null,
        lqtyPrice: null
    }

    componentDidMount() {
        const gql = `
        {
            systemStates(first:1, orderBy: sequenceNumber, orderDirection:desc)
              {
                tokensInStabilityPool
              }
        }
        `
        //Get Uniswap V2 price
        query(gql).then(data => {
            let arr = data.systemStates
            if (!arr || arr.length === 0) return
            let depositedLUSD = parseFloat(arr[0].tokensInStabilityPool)
            this.setState({
                ...this.state,
                depositedLUSD: depositedLUSD
            })
        }).catch(e => {
            console.error(e)
            this.setState({ failed: true })
        })

        queryLQTYPriceV2().then(price => {
            this.setState({
                ...this.state,
              lqtyPrice: price
            })
        }).catch(e => {
            console.error(e)
            this.setState({ failed: true })
        })
    }

    calculateAPR(depositedLUSD, lqtyPrice) {
        const issuanceFactor = 0.999998681227695000
        const deploymenttime = 1617611537
        const lqtysupplycap = 32000000

        const minutesPassed = (nowTimestamp() - deploymenttime) / 60
        const factor = Math.pow(issuanceFactor, minutesPassed)
        const lqtyRewards = lqtysupplycap * factor

        const years = dayjs().year() - 2020
        const yearlyDistribution = 1 - Math.pow(0.5, years)
        const apr = (lqtyRewards * lqtyPrice * yearlyDistribution) / depositedLUSD
        return parseFloat(apr * 100).toFixed(2)+"%"
    }

    render() {
      if (this.state.failed) return 'No data'
        const loaded = this.state.depositedLUSD && this.state.lqtyPrice
        return loaded ? this.calculateAPR(this.state.depositedLUSD, this.state.lqtyPrice) : 'Loading...'
    }
}

export default LusdAPR
